
/**
 * 코스 초안 요약 정보 (목록 조회용)
 */
export type PagedCourseDraftsContentItem = {
  /**
   * 코스 설명 (요약)
   * @nullable
   */
  description?: string | null;
  /** 코스 초안 ID */
  id: string;
  /** 강사 ID */
  instructorId: string;
  /** 강사 이름 */
  instructorName: string;
  /** 발행 여부 (한 번이라도 발행된 적이 있는지) */
  isPublished?: boolean;
  /**
   * 코스 난이도 (자유 텍스트 입력)
   * @minLength 1
   * @maxLength 50
   * @nullable
   */
  level?: string | null;
  /**
   * 썸네일 이미지 URL
   * @nullable
   */
  thumbnailUrl?: string | null;
  /** 코스 제목 */
  title: string;
  /** 최종 수정 시간 */
  updatedAt: string;
};
